import { AlertColor } from '@mui/material';
import { ClassNameMap } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import { useFeatureFlag } from './useFeatureFlag';

export type SnackbarProps = {
  pinned?: boolean;
  category?: AlertColor;
  isTiwScreenReaderEnabled?: boolean;
};

type SnackbarStylesProps = {
  pinned?: boolean;
  category?: AlertColor;
};

export const useStyles = makeStyles((theme) => ({
  snackBar: {
    left: ({ pinned }: { pinned?: boolean }) => (pinned ? 245 : 90),
    flexDirection: 'column',
    alignItems: 'flex-start',
    bottom: 20
  },
  item: {
    minWidth: theme.spacing(37.5),
    fontWeight: 'bold'
  },
  severity: ({
    category = 'success',
    isTiwScreenReaderEnabled
  }: SnackbarProps) => {
    switch (category) {
      case 'info':
        return {
          color: isTiwScreenReaderEnabled
            ? theme.palette.text.primary
            : theme.palette.info.dark,
          backgroundColor: theme.palette.info.light,
          boxShadow: theme.shadow?.paper
        };
      case 'warning':
        return {
          color: isTiwScreenReaderEnabled
            ? theme.palette.text.primary
            : theme.palette.warning.dark,
          backgroundColor: theme.palette.warning.light,
          boxShadow: theme.shadow?.paper
        };
      case 'error':
        return {
          color: isTiwScreenReaderEnabled
            ? theme.palette.text.primary
            : theme.palette.error.dark,
          backgroundColor: theme.palette.error.light,
          boxShadow: theme.shadow?.paper
        };
      default:
        return {
          color: isTiwScreenReaderEnabled
            ? theme.palette.text.primary
            : theme.palette.success.dark,
          backgroundColor: theme.palette.success.light,
          boxShadow: theme.shadow?.paper
        };
    }
  }
}));

export const useSnackbarStyles = ({
  pinned,
  category
}: SnackbarStylesProps): ClassNameMap => {
  const isTiwScreenReaderEnabled = useFeatureFlag('isTiwScreenReaderEnabled');

  const classes = useStyles({ pinned, category, isTiwScreenReaderEnabled });
  return classes;
};
